import { Icon } from '@distribusion/owl-frontend-ui'
import React from 'react'

import '@components/CompactTripCard/TripCardToggle/styles.scss'

interface TripCardToggleProps {
  text?: string
  isCollapsed: boolean
  onClickHandler?: () => void
}

const TripCardToggle = ({ text, isCollapsed, onClickHandler }: TripCardToggleProps) => {
  return (
    <div className="trip-card-toggle" onClick={onClickHandler}>
      {text}
      <Icon aria-hidden="true" name={isCollapsed ? 'chevron-up' : 'chevron-down'} size="medium" />
    </div>
  )
}

export default TripCardToggle
